import { render, staticRenderFns } from "./ViewPurchasesInvoicePage.vue?vue&type=template&id=bfd3a940"
import script from "./ViewPurchasesInvoicePage.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports